import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "react-modal-bootstrap";
import lodashGet from "lodash/get";
import isEmpty from "lodash/isEmpty";
import * as actions from "../../actions";
import AppointmentPreference from "../../components/Diagnostics/AppointmentPreference/AppointmentPreference";
import PaymentPreference from "../../components/Diagnostics/PaymentPreference/PaymentPreference";
import DiagnosticsOrderSuccess from "../../components/OrderSuccess/DiagnosticsOrderSuccess";
import OrderOnCallButton from "../../components/Button/OrderOnCallButton";
// import UploadRxOptions from '../../components/Diagnostics/UploadRxOptions/UploadRxOptions';
import * as Constants from "../../constants";
import { sendToGTM } from "../../utils/gtmHelper";
import * as AnalyticsHelper from "../../utils/analyticsHelper";
import FooterButtons from "../../components/Button/FooterButtons";
import Dropdown from "../../components/Dropdown/Dropdown";
import { closeDxLead } from "../../utils/api/salesForceLead";

import "./DiagnosticsReview.scss";
class DiagnosticsReview extends Component {
  constructor(props) {
    super(props);
    props.actions.changeHeaderState(Constants.SET_RX_AVAILABILITY);
    this.state = {
      profileEmail: props.profileEmail || "",
      openModal: false,
      orderDetails: {},
      emailError: "",
      showLoader: false,
      orderPlacementReasons: [
        {
          id: 1,
          name: "Pharmeasy",
        },
        {
          id: 3,
          name: "Docon",
        },
      ],
      selectedOrderPlacementReason: 1,
    };
  }

  setProfileEmail = () => {
    if (this.validateEmail(this.state.profileEmail)) {
      this.props.actions
        .customerProfileUpdate({
          newEmail: this.state.profileEmail,
          id: this.props.customerID,
        })
        .then((rs) => {
          console.log(rs);
        });
      this.setState({
        emailError: "",
      });
    } else {
      this.setState({
        emailError: "Enter a valid Email address",
      });
    }
  };

  backToAddress = () => {
    // this.props.actions.setOrderParams(this.state);
    browserHistory.push("/diagnostics/select-address");
  };

  placeOrder = async () => {
    const {
      selectedAddress,
      selectedLab,
      selectedPatient,
      selectedSlot,
      selectedPincode,
      selectedCityID,
      physicalReport,
      lead,
      salesforceLeadId,
    } = this.props;
    const placementReason =
      this.state.orderPlacementReasons.find(
        (o) => o.id === +this.state.selectedOrderPlacementReason
      ).name || "";

    const lpData = !isEmpty(this.props.selectedLPVariant)
      ? {
          variant_id: this.props.selectedLPVariant.id,
          program_id: this.props.selectedLPVariant.programId,
        }
      : {};

    const orderParams = {
      address_city_id: selectedCityID,
      address_id: selectedAddress.id,
      address_pincode: selectedPincode,
      lab_id: selectedLab.item_id,
      mce_id: selectedLab.mce_id,
      slot_date: selectedSlot.date,
      start_time: selectedSlot.start_time,
      end_time: selectedSlot.end_time,
      patient_id: +(selectedPatient.tenantPatientId),
      payment_mode_id: 1,
      physical_report_needed: physicalReport,
      business_entity: placementReason.toLowerCase(),
      new_payments_flag: null,
      ...lpData,
    };
    if (isEmpty(selectedSlot)) {
      alert("Please select appointment preference to continue");
      return null;
    }

    this.setState({
      showLoader: true,
      openModal: true,
    });

    const catalogConfigResponse = await this.getCatalogConfigData();
    const isNewPaymentFlowEnabled =
      lodashGet(
        catalogConfigResponse,
        "data.new_payments_flag.value",
        "false"
      ) === "true";
    orderParams.new_payments_flag = isNewPaymentFlowEnabled;
    this.props.actions.placeDiagnosticsOrder(orderParams).then((result) => {
      const { status, error } = result;

      if (status === 0 && error) {
        this.setState({
          showLoader: false,
          openModal: false,
        });
        setTimeout(() => {
          alert(error.message);
        });
        return;
      }

      if (!isEmpty(lead)) {
        this.props.actions
          .closeLead(lead, result.data.order_id)
          .then((resp) => {
            if (!resp.status) {
              alert(
                `${resp.error.message}. However, a new order has been successfully placed`
              );
            }
            this.props.actions.setLeadCx("");
          });
      }
      if (!isEmpty(salesforceLeadId)) {
        closeDxLead(result.data.order_id, salesforceLeadId);
      }
      this.props.actions.setLeadCx("");
      this.props.actions.setSalesForceLeadId("");
      this.props.actions
        .getDiagnosticsOrderDetails(result.data.order_id)
        .then((res) => {
          const lpData = !isEmpty(this.props.selectedLPVariant);
          if (lpData) {
            sendToGTM({
              eventLabel: "c_loyalty_order_placed",
              eventDetails: {
                order_type: "pathlab",
                item_name: this.props.selectedLPVariant.duration,
                item_id: this.props.selectedLPVariant.programId,
                item_price: this.props.selectedLPVariant.discounted_amount,
                checkout_type: "cart",
                parent_order_id: result.order_id,
                ...AnalyticsHelper.getCommonPayloadForAnalytics(
                  // eslint-disable-next-line react/prop-types
                  this.props.customer,
                  this.props.cart,
                  this.props.user
                ),
              },
            });
          }
          this.setState({
            orderDetails: res.data.order_summary,
            showLoader: false,
          });
        });
    });
  };

  getCatalogConfigData = async () => {
    const { selectedLab, selectedPincode } = this.props;

    const catalogConfigParams = {
      labId: selectedLab.item_id,
      mceId: selectedLab.mce_id,
      pincode: selectedPincode,
      platform: "order-on-call",
    };

    const catalogConfigResponse = await this.props.actions.catalogConfig(
      catalogConfigParams
    );

    return catalogConfigResponse;
  };

  cancelOrder = () => {
    if (confirm("Are you sure you want to cancel this order ?")) {
      // this.reset();
      this.props.actions.setLeadCx("");
      this.props.actions.cancelOrder();
      browserHistory.push("/customer-info");
    }
  };

  hideModal = () => {
    this.setState({
      openModal: false,
    });
    this.props.actions.cancelOrder();
    browserHistory.push("/customer-info");
  };

  changeEmail = (email) => {
    this.setState({
      profileEmail: email,
    });
  };

  validateEmail = (mail) => {
    if (
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
        mail
      )
    ) {
      return true;
    }
    return false;
  };

  onChangeOption = (reason) => {
    this.setState({
      selectedOrderPlacementReason: reason,
    });
  };

  render() {
    return (
      <div className="diagnosticsReviewContainer">
        <div className="reviewOrderTitle">Review Order</div>
        <AppointmentPreference />
        <PaymentPreference />
        <div className="emailWrapper">
          <div>Email address</div>
          <input
            onChange={(event) => this.changeEmail(event.target.value)}
            onBlur={this.setProfileEmail}
            placeholder="Example: ramesh.gupta@gmail.com"
            className="emailInputDR"
            type="email"
            value={this.state.profileEmail}
          />
          <div className="error">{this.state.emailError}</div>
        </div>
        <hr className="seperator" />
        <div className="orderPlacementReason">
          <div className="reasonTitle">Source of Customer</div>
          <Dropdown
            selectedOption={this.state.selectedOrderPlacementReason}
            list={this.state.orderPlacementReasons}
            onChangeOption={this.onChangeOption}
          />
        </div>
        {/* <UploadRxOptions /> */}
        <Modal
          isOpen={this.state.openModal}
          onRequestHide={this.hideModal}
          backdrop={false}
        >
          <ModalBody>
            {this.state.showLoader ? (
              <div>Placing your order...</div>
            ) : (
              <DiagnosticsOrderSuccess orderDetails={this.state.orderDetails} />
            )}
          </ModalBody>
          <ModalFooter>
            <OrderOnCallButton
              disabled={this.state.showLoader}
              text="SERVE NEXT ORDER"
              type={1}
              className="btn btn-default nextOrderBtn"
              loading={false}
              onClickFunction={this.hideModal}
            />
          </ModalFooter>
        </Modal>
        <FooterButtons
          backBtnText="Back to Patient/Address"
          backBtnClick={() => this.backToAddress()}
          proceedBtnClick={() => this.placeOrder()}
          proceedBtnText="Place Order"
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order"
        />
      </div>
    );
  }
}

DiagnosticsReview.propTypes = {
  actions: PropTypes.object,
  selectedPatient: PropTypes.object,
  selectedAddress: PropTypes.object,
  selectedPincode: PropTypes.number,
  selectedLab: PropTypes.object,
  selectedSlot: PropTypes.object,
  profileEmail: PropTypes.string,
  selectedCityID: PropTypes.number,
  customerID: PropTypes.number,
  physicalReport: PropTypes.bool,
  lead: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  salesforceLeadId: PropTypes.string,
};

DiagnosticsReview.defaultProps = {
  actions: {},
  selectedPatient: {},
  selectedAddress: {},
  selectedAddressDetails: {},
  selectedLab: {},
  selectedPincode: "",
  selectedSlot: {},
  profileEmail: "",
  selectedCityID: "",
  physicalReport: false,
  customerID: null,
  lead: "",
  salesforceLeadId: "",
};

export default connect(
  (state) => ({
    selectedPatient: state.patients.selectedPatient,
    selectedAddress: state.patients.selectedAddress,
    selectedCityID:
      state.patients.selectedAddress && state.patients.selectedAddress.cityId,
    selectedLab: state.diagnosticsCart.selectedLab,
    selectedSlot: state.diagnosticsSlots.selectedSlot,
    selectedLPVariant: state.diagnosticsCart.selectedLPVariant,
    selectedPincode: state.patients.selectedAddress.pincode,
    physicalReport: state.diagOrder.physicalReport,
    lead: state.customer.customerLead,
    salesforceLeadId: state.customer.salesforceLead,
    cart: state.cart,
    customer: state.customer,
    user: state.user,
    profileEmail: lodashGet(
      state.customer.customerDetails,
      "data.profile.profileEmail",
      ""
    ),
    customerID: lodashGet(
      state.customer.customerDetails,
      "data.profile.id",
      ""
    ),
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(DiagnosticsReview);
